import React from 'react';
import { Star, ShieldCheck, Truck, Award } from 'lucide-react';
import { Button } from './ui/Button';
import { ImagePlaceholder } from './ImagePlaceholder';
interface StickyCTAProps {
  onCtaClick: () => void;
}
export function StickyCTA({
  onCtaClick
}: StickyCTAProps) {
  const ratings = [{
    stars: 5,
    percentage: 92
  }, {
    stars: 4,
    percentage: 6
  }, {
    stars: 3,
    percentage: 1
  }, {
    stars: 2,
    percentage: 0
  }, {
    stars: 1,
    percentage: 1
  }];
  return <div className="bg-white rounded-2xl shadow-xl border border-slate-200 p-6 sticky top-20" data-id="element-31">
      {/* Headline */}
      <h3 className="font-sans font-bold text-xl text-slate-900 text-center mb-2 leading-tight" data-id="element-32">
        Stop Period Migraines Before They Start
      </h3>
      <p className="text-center text-sm text-slate-600 mb-4" data-id="element-33">
        Trusted by 2,800+ Women
      </p>

      {/* Product Image */}
      <div className="mb-4" data-id="element-34">
        <img src="https://cdn.magicpatterns.com/uploads/7JTrjsWL9CE9CURriTbqYp/ChatGPT_Image_1_Φεβ_2026,_08_07_50_μ.μ..png" alt="Glisera CycleCalm Migraine Relief Roll-On" className="w-full rounded-xl" data-id="element-35" />
      </div>

      {/* Star Rating */}
      <div className="mb-4" data-id="element-36">
        <div className="flex items-center justify-center gap-1 mb-2" data-id="element-37">
          {[...Array(5)].map((_, i) => <Star key={i} size={20} fill="#FCD34D" className="text-yellow-400" data-id="element-38" />)}
          <span className="ml-2 font-bold text-slate-900" data-id="element-39">4.9 out of 5</span>
        </div>
        <p className="text-center text-sm text-slate-600 mb-3" data-id="element-40">
          2,847 customer ratings
        </p>

        {/* Rating Breakdown */}
        <div className="space-y-1" data-id="element-41">
          {ratings.map(rating => <div key={rating.stars} className="flex items-center gap-2 text-xs" data-id="element-42">
              <span className="w-8 text-slate-700 font-medium" data-id="element-43">
                {rating.stars}★
              </span>
              <div className="flex-1 bg-slate-200 rounded-full h-2 overflow-hidden" data-id="element-44">
                <div className="bg-yellow-400 h-full rounded-full transition-all duration-500" style={{
              width: `${rating.percentage}%`
            }} data-id="element-45" />
              </div>
              <span className="w-10 text-right text-slate-600 font-medium" data-id="element-46">
                {rating.percentage}%
              </span>
            </div>)}
        </div>
      </div>

      {/* CTA Button */}
      <Button fullWidth size="lg" onClick={onCtaClick} className="mb-4 shadow-lg shadow-[#1F3A2A]/20" data-id="element-47">
        CLAIM 30% OFF NOW →
      </Button>

      {/* Trust Badges */}
      <div className="space-y-2 text-xs text-slate-600" data-id="element-48">
        <div className="flex items-center gap-2" data-id="element-49">
          <ShieldCheck size={16} className="text-[#1F3A2A] flex-shrink-0" data-id="element-50" />
          <span data-id="element-51">60-Day Money-Back Guarantee</span>
        </div>
        <div className="flex items-center gap-2" data-id="element-52">
          <Truck size={16} className="text-[#1F3A2A] flex-shrink-0" data-id="element-53" />
          <span data-id="element-54">Fast FREE US Shipping</span>
        </div>
        <div className="flex items-center gap-2" data-id="element-55">
          <Award size={16} className="text-[#1F3A2A] flex-shrink-0" data-id="element-56" />
          <span data-id="element-57">Doctor Recommended Formula</span>
        </div>
      </div>
    </div>;
}